import { IDTOMessageRule } from '@/api/api-messenger';
import MessageTemplate from './MessageTemplate';
import Campaign from './Campaign';
import Tab from './Tab';
import Service from './Service';
import MessageType, { EmailMessageTypeChannel } from './MessageType';
import MessageEventType, { BuiltInEventTypes } from './MessageEventType';
import { toModelEntities, cloneModel } from './model-utils';
import MessageHandlebar from './MessageHandlebar';

export interface MessageRuleMapping {
  messageCenterEventTypesById: Map<number, MessageEventType>;
  messageCenterCampaignsById: Map<number, Campaign>;
  messageCenterHandlebarsById: Map<number, MessageHandlebar>,
  messageCenterMessageTypesById: Map<number, MessageType>,
  messageCenterServicesById: Map<number, Service>,
  messageCenterTabsById: Map<number, Tab>,
}

export default class MessageRule {
  id: number;

  sendBcc: boolean;

  isDefault: boolean;

  isInactive: boolean;

  isDeleted: boolean;

  sendAtSpecificTime?: string;

  sendDaysInAdvance?: number;

  sendDaysAfter?: number;

  templates: MessageTemplate[];

  campaign?: Campaign | null = null;

  service?: Service | null = null;

  tab?: Tab | null = null;

  eventType?: MessageEventType;

  messageType?: MessageType;

  isDisabled?: boolean; // cannot be edited, displayed as inactive

  // get isDefault() {
  //   return this.messageType?.messageType === EmailMessageTypeChannel
  //   && BuiltInEventTypes.includes(this.eventType?.type ?? '')
  //   && this.service == null && this.campaign == null && this.tab == null;
  // }

  constructor(o?: IDTOMessageRule, m?: MessageRuleMapping) {
    this.id = o?.messageRuleId ?? 0;
    this.sendBcc = o?.sendBcc ?? false;
    this.isDefault = o?.isDefault ?? false;
    this.isInactive = o?.isInactive ?? o?.isDeleted ?? false;
    this.isDeleted = o?.isDeleted ?? false;
    this.sendAtSpecificTime = o?.sendAtSpecificTime || '12:00';
    this.sendDaysInAdvance = o?.sendDaysInAdvance;
    this.sendDaysAfter = o?.sendDaysAfter;

    this.campaign = m?.messageCenterCampaignsById.get(o?.campaignId ?? NaN) ?? null;
    this.service = m?.messageCenterServicesById.get(o?.serviceId ?? NaN) ?? null;
    this.eventType = m?.messageCenterEventTypesById.get(o?.eventTypeId ?? NaN);
    this.messageType = m?.messageCenterMessageTypesById.get(o?.messageTypeId ?? NaN);
    this.tab = m?.messageCenterTabsById.get(o?.tabId ?? NaN) ?? null;

    this.templates = toModelEntities(MessageTemplate, o?.messageTemplates, { stringOrderField: 'locale', mapping: m });
  }

  toDto(): IDTOMessageRule {
    const dto: IDTOMessageRule = {
      messageRuleId: this.id > 0 ? this.id : 0,
      campaignId: this.campaign?.id,
      serviceId: this.service?.id,
      tabId: this.tab?.id,
      eventTypeId: this.eventType?.id,
      messageTypeId: this.messageType?.id,
      sendBcc: this.sendBcc,
      isDefault: this.isDefault,
      isInactive: this.isInactive,
      messageTemplates: this.templates.map((o) => o.toDto()),
      sendAtSpecificTime: this.sendAtSpecificTime,
      sendDaysInAdvance: this.sendDaysInAdvance,
      sendDaysAfter: this.sendDaysAfter,
      isDeleted: this.isDeleted,
    };
    return dto;
  }

  clone(): MessageRule {
    const copy = new MessageRule();
    Object.assign(copy, this);
    copy.templates = this.templates.map((o) => cloneModel(o));
    return copy;
  }

  static compare(o1: MessageRule, o2: MessageRule): number {
    let res = (o1.messageType?.id ?? 0) - (o2.messageType?.id ?? 0); if (res !== 0) return res;
    res = (o1.eventType?.id ?? 0) - (o2.eventType?.id ?? 0); if (res !== 0) return res;
    return o1.id - o2.id;
  }
}
